@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@mixin shimmer-bar {
  background-color: #c8c8c8;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.7) 50%, transparent 100%);
    transform: translateX(-100%);
    animation: shimmer 1.5s ease-in-out infinite;
  }
}

.skeleton_product {
  display: flex;
  max-width: 1190px;
  margin: 20px auto 0;
  justify-self: center;
  width: 100%;
  gap: 0 30px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  @media screen and (min-width: 992px) {
    display: grid;
    grid-template-columns: 55% 45%;
  }
}

.skeleton_product_left {
  flex: 1;
  max-width: 700px;
}

.skeleton_product_right {
  flex: 1;
  padding-left: 2rem;

  @media (max-width: 767px) {
    padding-left: 0;
  }
}

.skeleton_images {
  display: flex;
  gap: 5px;
  height: 548px;
  max-height: 548px;

  @media (max-width: 767px) {
    flex-direction: column-reverse;
    height: auto;
  }
}

.skeleton_thumbs {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100px;
  flex-shrink: 0;
  overflow: hidden;

  @media (max-width: 767px) {
    flex-direction: row;
    width: 100%;
    height: auto;
    overflow-x: hidden;
  }
}

.skeleton_thumb {
  width: 98px;
  height: 98px;
  flex-shrink: 0;
  border-radius: 4px;
  @include shimmer-bar;

  @media (max-width: 767px) {
    width: 72px;
    height: 72px;
  }
}

.skeleton_main_image {
  flex: 1;
  border-radius: 4px;
  @include shimmer-bar;

  @media (max-width: 767px) {
    width: 100%;
    height: 90vw;
    max-height: 455px;
  }
}

.skeleton_title {
  height: 21px;
  width: 82%;
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 1rem;
  @include shimmer-bar;
}

.skeleton_review {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 10px;
}

.skeleton_stars {
  display: flex;
  gap: 0.25rem;
}

.skeleton_star {
  width: 17px;
  height: 15px;
  border-radius: 2px;
  @include shimmer-bar;
}

.skeleton_review_text {
  height: 16px;
  width: 200px;
  border-radius: 4px;
  @include shimmer-bar;
}

.skeleton_step_nav {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.skeleton_step_indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.skeleton_step_number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  @include shimmer-bar;
}

.skeleton_step_text {
  height: 16px;
  width: 80px;
  border-radius: 4px;
  @include shimmer-bar;
}

.skeleton_step_content {
  // margin-bottom: 10px;
  // padding: 10px;
  // border: 2px solid #10b981;
  // border-radius: 12px;
  // background-color: #f0fdf4;
}

.skeleton_step_title {
  height: 32px;
  width: 60%;
  border-radius: 8px;
  margin-bottom: 5px;
  margin-inline: auto;
  @include shimmer-bar;
}

.skeleton_dropdowns {
  display: flex;
  gap: 1rem;
  margin-bottom: 5px;

  @media (max-width: 767px) {
    flex-direction: column;
  }
}

.skeleton_dropdown {
  flex: 1;
  height: 48px;
  border-radius: 8px;
  @include shimmer-bar;
}

.skeleton_features {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.skeleton_feature {
  height: 20px;
  flex: 1;
  border-radius: 4px;
  @include shimmer-bar;
}

.skeleton_button {
  height: 56px;
  width: 100%;
  border-radius: 8px;
  margin-top: 10px;
  @include shimmer-bar;
}
